

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETEMAILCONFIG= createAsyncThunk(
  "getEmailConfig/getEmailConfig",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getEmailConfigSlice = createSlice({
  name: "getEmailConfigSlice",
  initialState: {
    getEmailConfig: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetEmailConfig: (state) => {
        state.getEmailConfig.loading = false
        state.getEmailConfig.error = false
        state.getEmailConfig.data = []
        state.getEmailConfig.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETEMAILCONFIG.fulfilled, (state, action) => {
      state.getEmailConfig = {
        ...state.getEmailConfig,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEMAILCONFIG.pending, (state, action) => {
      state.getEmailConfig = {
        ...state.getEmailConfig,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEMAILCONFIG.rejected, (state, action) => {
      state.getEmailConfig = {
        ...state.getEmailConfig,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getEmailConfigAction = {
    GETEMAILCONFIG,
};

export { getEmailConfigAction };
export default getEmailConfigSlice.reducer;
export const {setInitialStateOfgetEmailConfig} = getEmailConfigSlice.actions
